import {rqCreateSearchRequest} from './rqHttpsUtils';
import {useQuery} from '@tanstack/react-query';
import {RQ_GET_MENUS_USER_ID_API} from './constants';

export const RQGetSideMenusData = (payload, options = {}) => {
  return useQuery({
    queryKey: ['rq_get_side_menu_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {userId, filter, token} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_MENUS_USER_ID_API,
        null,
        token,
        {id: userId},
        signal,
        filter,
      );
    },
    ...options,
  });
};

export const RQCommonListData = (payload, options = {}) => {
  return useQuery({
    queryKey: [payload?.name?.toLowerCase(), payload],
    queryFn: async ({queryKey, signal}) => {
      const {token, userId, locationId, api, misc, filter = {}} = queryKey[1];
      return rqCreateSearchRequest(
        api,
        null,
        token,
        {...misc, userId: userId, locationId: locationId},
        signal,
        filter,
      );
    },

    ...options,
  });
};
